import React from "react"
export default function Layout({ children }) {
  return (
    <div class="container-fluid">
      {children}
    </div>
  )
}